module.exports = __webpack_public_path__ + "static/media/2C.136dab43.png";